export default "__VITE_ASSET__COQEP5$O__"